export enum AuctionLotBiddingStatus {
  ReceivingBids = 'receiving-bids',
  NotReceivingBids = 'not-receiving-bids',
}
